import { useAtom, useAtomValue } from 'jotai';
import { atom } from 'jotai';
import { useCallback } from 'react';
import { shouldShowDevTool } from './DevTool';
// Private atoms - only accessible through useDevTool hook
const devToolConfigAtom = atom({
    searchRegion: {
        enabled: false,
    },
});
const devToolDataAtom = atom({
    searchRegion: null,
});
export const useDevTool = () => {
    const [data, setData] = useAtom(devToolDataAtom);
    const config = useAtomValue(devToolConfigAtom);
    const trackSearchCircle = useCallback((location, radiusMeters) => {
        if (!shouldShowDevTool())
            return;
        if (config.searchRegion.enabled) {
            setData(prev => (Object.assign(Object.assign({}, prev), { searchRegion: {
                    type: 'circle',
                    location,
                    radiusMeters,
                    timestamp: Date.now(),
                } })));
        }
    }, [config.searchRegion.enabled, setData]);
    const trackSearchRectangle = useCallback((leftTopLocation, rightBottomLocation) => {
        if (!shouldShowDevTool())
            return;
        if (config.searchRegion.enabled) {
            setData(prev => (Object.assign(Object.assign({}, prev), { searchRegion: {
                    type: 'rectangle',
                    leftTopLocation,
                    rightBottomLocation,
                    timestamp: Date.now(),
                } })));
        }
    }, [config.searchRegion.enabled, setData]);
    const shouldShowSearchRadius = useCallback(() => {
        if (!shouldShowDevTool())
            return false;
        return config.searchRegion.enabled;
    }, [config.searchRegion.enabled]);
    // Return organized by feature
    return {
        searchRegion: {
            data: data.searchRegion,
            trackCircle: trackSearchCircle,
            trackRectangle: trackSearchRectangle,
            shouldShow: shouldShowSearchRadius,
            enabled: config.searchRegion.enabled,
        },
        // Add more features here as needed
        // otherDebugFeature: {
        //   data: data.otherDebugFeature,
        //   track: trackOtherFeature,
        //   shouldShow: shouldShowOtherFeature,
        //   enabled: config.otherDebugFeature.enabled,
        // },
    };
};
// Internal hook for DevTool component configuration management
export const useDevToolConfig = () => {
    return useAtom(devToolConfigAtom);
};
